import React, { Component } from 'react';
import NavButtonMiami from './NavButtonMiami';
import BackButtonMiami from './BackButtonMiami';
import miamiConstants from './MiamiConstants';
import shared from '../../../utils/shared.js';
import {dp} from '../../../utils/shared.js';
import _ from 'lodash';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class MessageMiami extends Component {

  constructor(props) {
    super(props);
    this._subscribeModule = null;
    this._backButton = null;
    this._colorPallette = null;
    this.getSubscribeModule();

    this._logo = null;
    // this._story = _.find(this.props.module.stories, { contents: { custom_fields: { story_type: { val: "message" } } } });
    this._story = _.get(this.props.module, 'children[0]', null);
  }

  componentDidMount() {
    this.props.setMenuBtn(2, 1,'/miami/nav');
  }

  getBackgroundImage = () => {
    const defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._logo = shared.dp(this.props.screen, _.get(rootFolder, 'contents.images[0]', null), null);
    return shared.dp(this.props.screen, _.get(this.props.module, 'contents.images[1]', null), null);
  }

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    this._backButton = dp(this.props.screen, _.get(menu, 'contents.custom_fields.images[0]', null), null);
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

  renderBackButton = () => {
    if (this.props.mode === "story") {
      return (
        <BackButtonMiami 
          colorPallette={this._colorPallette}
          backButton={this._backButton}
          unit={this.props.screen.r9_16.p10}
          width="3.90625vh"
          height={miamiConstants.backButtonHeight}
          top={this.props.screen.screenHeight / 2 + this.props.screen.r9_16.p10 * 1.15}
          clickAction={this.handleBack}
          text={'back'}
           mode={this.props.mode}>
        </BackButtonMiami>
      );
    } else {
      return (<NavButtonMiami unit={this.props.screen.r9_16.p10} width={this.props.screen.r9_16.p10 * .7} height={this.props.screen.r9_16.p10 * .7} clickAction={this.handleBack} text={'back'} mode={this.props.mode} left='90%' top='95%'>
        <div style={{ textAlign: 'center', marginTop: this.props.screen.r9_16.p10 * 0.041666667 }}>
          <span style={{ fontSize: this.props.screen.r9_16.p10 * .5, color: 'white', fontWeight: 'bold' }}>X</span>
        </div>
      </NavButtonMiami>);
    }
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  render() {
    let helpButton = "/img/miami/general/help_button.png";
    let uiStrip = "/img/miami/general/rainbowuistrip.png";
    if (this._colorPallette === "adaptive") {
      helpButton = "/img/miami/general/help_button_green.png";
      uiStrip = "/img/miami/general/rainbowuistrip_green.png";
    }
    const backgroundImage = this.getBackgroundImage();
    const storyImage = shared.dp(this.props.screen, this._story.contents.images[0]);
    // const storyImage = shared.presetDp("cfo", _.get(this._story, 'contents.images[0]', {path: '/img/ui/', file_name: 'image_default.png'}), this.props.screen);
    const unit = this.props.screen.r9_16.p10;
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    const subtitleRichText = new QuillDeltaToHtmlConverter(_.get(this._story, 'contents.custom_fields.subtitle.val.ops', _.get(this._story, 'contents.custom_fields.subtitle.default.ops', null)), {}).convert();
    const bodyRichText = new QuillDeltaToHtmlConverter(_.get(this._story, 'contents.custom_fields.body.val.ops', _.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();
    const quoteRichText = new QuillDeltaToHtmlConverter(_.get(this._story, 'contents.custom_fields.quote.val.ops', _.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();

    return (
      <div style={{ height: this.props.screen.r9_16.height, width: '100%', backgroundSize: backgroundSize, backgroundImage: "url("+backgroundImage+")" }}>
        <div style={{ position:"absolute", width: this.props.screen.screenWidth / this.props.screensNumber }}>
        {/* <div style={{ height:"2vh" }}></div> */}
          <div style={{ height: "26.979166667vh", position:"absolute", width:"100%", display:"flex", justifyContent:"center", alignItems: "center" }}>
            <img alt="Logo" src={this._logo} style={{ display: 'block', margin: 'auto', width: '35vw' }} />
          </div>
          <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: unit * .25, top:"26.979166667vh" }} />
          <div style={{ height:"2.29vh" }}></div>
          <div style={{ display:"flex", justifyContent:"center", fontFamily:"opensans-regular", position:"absolute", top: "29.5vh" }}>
            <div style={{ color:"#4A4A4A", borderRadius:"3.125vh", backgroundColor: 'white', height: "58.333333333vh", maxHeight:"58.333333333vh", padding: "4.166666667vh", width:"70%", overflowY:"scroll"  }}>
              <span style={{ fontSize: "2.135416667vh", fontWeight: "bold", color: '#4A4A4A', fontFamily: "opensans-bold"}}>
                {this._story.name}
              </span>
              <div style={{ height:"1.5vh" }}></div>
              <span style={{ fontSize:"1.458333333vh" }} className="no-margin">
                <div dangerouslySetInnerHTML={{ __html: subtitleRichText}}/>
              </span>
              <div style={{ height:"1.5vh" }}></div>
              <div style={{ display: "table", textAlign: "left", width: "100%", justifyContent:"center" }}>
                <div style={{ display: "table-row" }}>
                  <div style={{ display: "table-cell", width: "65%" }}>
                    <span style={{ lineHeight: "1.302083333vh", overflowY: "hidden", maxHeight: "47.0vh", color: "#404040",fontSize:"0.833333333vh" }}>
                      <div dangerouslySetInnerHTML={{ __html: bodyRichText}}/>
                    </span>
                    <div style={{ height:"4vh" }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ width: this.props.screen.screenWidth / 2, left: this.props.screen.screenWidth / 2, position: "absolute", color:"#4A4A4A", top:"3.5vh" }}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ backgroundColor:"white", borderRadius:"3.125vh", height:"91vh", paddingBottom:"2vh", width:"86%" }}>
              <div style={{ width:"100%", backgroundImage: "url("+storyImage+")", backgroundSize:"cover", height:"70vh", backgroundPosition:"center", borderTopRightRadius:"3.125vh",borderTopLeftRadius:"3.125vh"  }}>
              </div>
              <div style={{ display:"table", height:"21vh" }}>
                <div style={{ display:"table-cell", verticalAlign:"middle", paddingRight:"1%", paddingLeft:"3%", width:"52%", }}>
                  <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.screenHeight * .002, width: "85%" }} src={uiStrip} />
                  <div className="no-margin" style={{ color: '#4A4A4A', paddingTop: "1.5625vh", paddingBottom: "1.5625vh", width: "85%", margin: "0 auto", textAlign: "center", lineHeight:"1.3020vh" }}>
                    <div dangerouslySetInnerHTML={{ __html: quoteRichText}}/>
                  </div>
                  <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.screenHeight * .002, width: "85%" }} src={uiStrip} />
                </div>
                <div style={{ display:"table-cell", verticalAlign:"middle", paddingRight:"5%", paddingLeft:"3%", width:"36%", }}>
                  <img alt="Be The Change" onClick={this.redirect} style={{ backgroundColor: 'white', display: "block", margin: "auto", width: "80%", textAlign: "center" }} src={helpButton} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>       

    )
  }
}

export default MessageMiami


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/MessageMiami.js